import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { api } from 'src/api';
import { getSuggestionKey } from './suggestionModel';

// The api layer is called directly rather than through the store action of the same name: that
// action replaces the one property's utility setup the property pages work from, and a bill can be
// for several properties at once.
const NO_OPTIONS = {
  cancelToken: undefined
};

/** A utility with no deduction configured has none to send; zero is a deduction of nothing. */
function percent(value) {
  if (value === null || value === undefined || value === '') return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
}
async function fetchProperty(propertyId) {
  try {
    const resp = await api.Properties.getPropertyUtilityProvidersV3({
      propertyId
    }, NO_OPTIONS, true);
    const providers = resp !== null && resp !== void 0 && resp.isSuccessful ? resp.response || [] : [];
    return providers.flatMap(provider => provider.utilities || []).map(utility => [getSuggestionKey(propertyId, utility.utilityId), percent(utility.goodWillDeduction)]);
  } catch (_unused) {
    // Nothing is lost by not knowing: a suggestion asked for without a deduction is answered with
    // the one the property utility is configured with, which is the number this was reading.
    return [];
  }
}

/**
 * The goodwill deduction each of the given properties has configured for each of its utilities,
 * keyed by property and utility. It is what the allocation deducts unless someone changes it for
 * this bill, so it is both what the tables should show before the service has answered and what the
 * suggestion should be asked for.
 */
export function usePropertyGoodwillDeductions(propertyIds) {
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    deductions = _useState2[0],
    setDeductions = _useState2[1];
  // The set of properties is the dependency; a re-render listing the same ones changes nothing.
  const signature = [...new Set(propertyIds || [])].filter(Boolean).sort().join(',');
  useEffect(() => {
    const wanted = signature ? signature.split(',') : [];
    if (!wanted.length) {
      setDeductions({});
      return undefined;
    }
    let isActive = true;
    Promise.all(wanted.map(fetchProperty)).then(perProperty => {
      if (!isActive) return;
      setDeductions(Object.fromEntries(perProperty.flat().filter(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          deduction = _ref2[1];
        return key && deduction !== null;
      })));
    });
    return () => {
      isActive = false;
    };
  }, [signature]);
  return deductions;
}